var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsumer3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#EEF4FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7321_358)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 20,
    r: 8,
    fill: "#F3A218"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 8,
    fill: "#3E3838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 28H12L28 44V28Z",
    fill: "#DB8D06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 28H44L28 44V28Z",
    fill: "#134AB9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7321_358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumer3);
export default __webpack_public_path__ + "static/media/consumer3.61b11ba59c3de0a6178328950fc874f7.svg";
export { ForwardRef as ReactComponent };